<template>
    <div id="legalNotices">
        <button id="show-footer-legal-texts" class="btn-legal-notices" @click="onClick"
                @keyup.enter="onClick" tabindex="0" v-text="$tb('components.legal.link')">
        </button>
        <div :id="getFullModalId" class="ui basic modal" :dir="checkDirRightToLeft" :style="checkStyleTextAlignRight">
            <div class="ui icon header">
                <div tabindex="0" :id="getFullModalId + '-title'" class="title" v-text="legalNotices.title"
                     @keydown.shift.tab.prevent="focusElement('close-button')"></div>
            </div>
            <div id="legalNoticesTextContent" class="content" v-html="legalNotices.legalText"></div>
            <div class="actions">
                <button type="button" :id="getFullModalId + '-close-button'" tabindex="0"
                        class="ui inverted cancel button"
                        @keyup.enter.prevent="onEnter" @keydown.tab.exact.prevent="focusElement('title')">
                    <i class="angle left icon"></i><span v-text="$t('common.button.back')"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mixin } from '../../js/ciam-mixin.js'
import Vue from 'vue'
import { ARABIC_LANGUAGE } from '../../js/constants'

/* global contextPath */

export default {
  mixins: [mixin],
  props: {
    modalId: String,
    active: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      legalNotices: [],
      loaded: false,
      currentLanguage: ''
    }
  },
  methods: {
    onClick: function () {
      if (this.active) {
        const desiredLanguage = this.getLanguage()

        console.debug(`Legal notices language comparison [current=${this.currentLanguage}, next=${desiredLanguage}]`)
        if (!this.loaded || this.currentLanguage !== desiredLanguage) {
          this.loadNoticesAndDoSetup(desiredLanguage)
        } else {
          this.showModal()
        }
      }
    },
    loadNoticesAndDoSetup (desiredLanguage) {
      this.getLoader.startLoading()
      this.currentLanguage = desiredLanguage

      const url = contextPath + `/toas/legalNotices?language=${this.currentLanguage}&country=${this.getTouchpointCountry()}`

      console.debug(`Fetching legal notices [language=${this.currentLanguage}, country=${this.getTouchpointCountry()}]`)

      $.get(url).done(this.setUpModal).fail(this.onError)
    },
    setUpModal: function (response) {
      this.legalNotices = response
      // because vue is updating the data asynchronously we have to wait a tick,
      // to avoid having weird representation of the modal
      Vue.nextTick(this.showModal)
    },
    showModal: function () {
      this.modifyHashLinks()
      this.getLoader.stopLoading()
      $(`#${this.getFullModalId}`).modal({ onShow: this.scrollTopOfModal }).modal('refresh').modal('show')
      $(`#${this.getFullModalId}`).focus()
    },
    onError: function (r) {
      console.error(r)
      $('.ui.form').form('add errors', [this.$t('errors.registration.loadLegalTexts')])
      this.getLoader.stopLoading()
    },
    getLanguage: function () {
      const defaultValue = this.$store.state.lang ? this.$store.state.lang : 'en'
      return this.getValue('#language-content', defaultValue)
    },
    getValue: function (selector, defVal) {
      const item = $(selector)
      if (item.length > 0) {
        return item.text()
      }
      return defVal
    },
    modifyHashLinks: function () {
      if (!this.loaded) {
        console.debug('Setting up hash links in modal')
        $(`#${this.getFullModalId} > .content a[href*="#"]`).click(function (event) {
          const target = document.getElementById(event.target.hash.replace('#', ''))
          if (target !== undefined && target !== null) {
            target.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }
          event.preventDefault()
        })
        this.loaded = true
      }
    },
    scrollTopOfModal: function () {
      console.debug('Scrolling to top of modal')
      $(`#${this.getFullModalId}`).get(0).scrollIntoView(true)
    },
    onEnter: function () {
      $(`#${this.getFullModalId}`).modal('hide')
    },
    focusElement: function (identifier) {
      $(`#${this.getFullModalId}-${identifier}`).focus()
    }
  },
  computed: {
    checkDirRightToLeft: function () {
      const language = this.$store.state.lang ? this.$store.state.lang : ''
      if (language === ARABIC_LANGUAGE) {
        return 'rtl'
      }
      return null
    },
    checkStyleTextAlignRight: function () {
      const language = this.$store.state.lang ? this.$store.state.lang : ''
      if (language === ARABIC_LANGUAGE) {
        return 'text-align: right'
      }
      return null
    },
    getFullModalId: function () {
      return 'modal-legalText-' + this.modalId
    },
    getLoader: function () {
      return this.$parent
    }
  },
  beforeDestroy: function () {
    const modal = document.getElementById(this.getFullModalId)
    if (modal !== undefined && modal != null) {
      modal.remove()
      console.debug('Modal removed')
    }
  }
}
</script>

<style scoped>
    .title {
        padding: 0 40px;
        text-decoration: underline;
    }

    .ui.header {
        border: aliceblue;
        margin: calc(2rem - .14285714em) 0 1rem;
        padding: 0 0;
        font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-weight: 700;
        line-height: 1.28571429em;
        text-transform: none;
        color: #fff;
    }

    .ui.icon.header {
        display: inherit;
        text-align: center;
        margin: 2rem 0 1rem;
    }

    .btn-legal-notices {
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        font-size: 18px !important;
        color: #3887C1;
        cursor: pointer;
        font-weight: 700;
        font-family: DaimlerCS-Demi, sans-serif;
        background: none !important;
        border: none;
        padding: 0 !important;
    }

    .btn-legal-notices:active,
    .btn-legal-notices:hover {
        color: #5DABEC !important
    }

    @media (min-width: 666px) {
        .btn-legal-notices {
            color: #999999;
            font-size: 14px !important;
        }
    }
</style>
